import React from "react";
import {
  Box,
  Typography,
  Stack,
  alpha,
  useTheme,
} from "@mui/material";
import { Flag as FlagIcon } from "@mui/icons-material";
import SearchableSelect from "../../FormFields/CustomSelect/SearchableSelect";
import CustomInput from "../../FormFields/CustomInput/CustomInput";
import { statusOptions } from "../incident.config";

const CurrentStatus = ({ formData, handleFormChange }) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: "8px",
            bgcolor: alpha(theme.palette.primary.main, 0.08),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FlagIcon sx={{ fontSize: 20, color: theme.palette.primary.main }} />
        </Box>
        <Box>
          <Typography
            variant="h6"
            fontWeight={700}
            color="#1A1A2E"
            fontSize="0.95rem"
          >
            Current Status
          </Typography>
          <Typography variant="caption" color="#6B7280" fontSize="0.7rem">
            Status, references and follow-up details
          </Typography>
        </Box>
      </Box>

      <Stack spacing={2}>
        <SearchableSelect
          name="status"
          label="Status"
          value={
            statusOptions.find((o) => o.value === formData?.status) || null
          }
          onChange={(opt) =>
            handleFormChange({
              target: { name: "status", value: opt?.value ?? "" },
            })
          }
          options={statusOptions}
          placeholder="Select status..."
          getOptionLabel={(o) => o.label}
          getOptionValue={(o) => o.value}
        />

        <CustomInput
          name="reference_number"
          label="Reference Number"
          value={formData?.reference_number || ""}
          onChange={handleFormChange}
        />

        <CustomInput
          name="evidence_de_briefing"
          label="Evidence of de-briefing"
          value={formData?.evidence_de_briefing || ""}
          onChange={handleFormChange}
          multiline
          rows={3}
          placeholder="Describe any de-briefing evidence..."
        />

        <CustomInput
          name="follow_up_required"
          label="Follow up required"
          value={formData?.follow_up_required || ""}
          onChange={handleFormChange}
          multiline
          rows={3}
          placeholder="What follow-up is required?"
        />

        <CustomInput
          name="outcome"
          label="Outcome"
          value={formData?.outcome || ""}
          onChange={handleFormChange}
          multiline
          rows={3}
          placeholder="Describe the outcome..."
        />
      </Stack>
    </Box>
  );
};

export default CurrentStatus;